<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">项目名称：</div>
        <el-input
          placeholder="请输入项目名称"
          size="medium"
          v-model="queryInfo.depName"
          @change="getDepList()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位卡片区域 -->
      <div class="leftBox">
        <!-- 单位树 -->

        <el-tree
          class="treeBox"
          :data="depTrees"
          :props="defaultTreesProps"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <!-- 右边单位卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加单位按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddDepDialogVisible = true"
          >
            新增
          </el-button>
          <!-- 单位信息表格区域 -->
          <el-table
            :data="depList"
            :header-cell-style="{
              background: '#0395d9',
              color: '#505255',
              textAlign: 'center',
            }"
            :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
          >
            <el-table-column prop="depName" label="项目名称"> </el-table-column>
            <el-table-column prop="depCode" label="项目编号"> </el-table-column>
            <el-table-column prop="depPhone" label="项目电话">
            </el-table-column>
            <!-- <el-table-column prop="department_parent_name" label="上级单位名称">
            </el-table-column> -->

            <el-table-column label="操作" width="130">
              <template v-slot="slot">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="bottom-start"
                >
                  <el-button
                    type="warning"
                    size="small"
                    circle
                    icon="el-icon-edit"
                    @click="openUpdateDep(slot.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  content="删除"
                  placement="bottom-start"
                  effect="dark"
                >
                  <el-button
                    type="danger"
                    size="small"
                    circle
                    icon="el-icon-delete"
                    @click="deleteDepByid(slot.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加单位信息对话框 -->
    <el-dialog
      title="新增项目"
      :visible.sync="AddDepDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddDepDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addDepFormRef"
        :rules="AddDepRules"
        :model="DepInfo"
        label-width="80px"
      >
        <el-form-item prop="depName" label="项目名称">
          <el-input
            placeholder="请输入项目名称"
            v-model="DepInfo.depName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="depCode" label="项目编号">
          <el-input
            placeholder="请输入项目编号"
            v-model="DepInfo.depCode"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="depParentId" label="所属项目">
          <el-select
            v-model="DepInfo.depParentId"
            placeholder="请选择"
            ref="MySelect"
          >
            <el-option
              :key="DepInfo.depParentId"
              :label="checkDname"
              :value="DepInfo.depParentId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick2"
            >
            </el-tree>
          </el-select>
        </el-form-item>

        <el-form-item prop="depPhone" label="项目电话">
          <el-input
            placeholder="请输入项目电话"
            v-model="DepInfo.depPhone"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddDepDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddDep()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改单位信息对话框 -->
    <el-dialog
      title="修改项目信息"
      :visible.sync="UpdateDepDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updateDepFormRef"
        :rules="AddDepRules"
        :model="UpdateInfo"
        label-width="80px"
      >
        <el-form-item prop="depName" label="项目名称">
          <el-input
            placeholder="请输入项目名称"
            v-model="UpdateInfo.depName"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="depCode" label="项目编号">
          <el-input
            placeholder="请输入项目编号"
            v-model="UpdateInfo.depCode"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="departmentParentId" label="所属项目">
          <el-select
            v-model="UpdateInfo.depParentId"
            placeholder="请选择"
            ref="MyUpdateSelect"
          >
            <el-option
              :key="UpdateInfo.depParentId"
              :label="UpdateInfo.depParentName"
              :value="UpdateInfo.depParentId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleUpdateDepNodeClick"
            >
            </el-tree>
          </el-select>
        </el-form-item>

        <el-form-item prop="depPhone" label="项目电话">
          <el-input
            placeholder="请输入项目电话"
            v-model="UpdateInfo.depPhone"
            clearable
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateDepDialog = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>

export default {
  data() {
    return {
      // 单位列表信息
      depList: [],
      // 单位列表查询信息
      queryInfo: {
        // 单位名称
        depName: "",
        // 单位id
        depId: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      //  单位总数量
      total: 0,
      // 单位树信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName",
      },
      // 控制增加单位对话框的显示和隐藏
      AddDepDialogVisible: false,
      // 单位实体
      DepInfo: {
        // 单位名称
        depName: "",
        // 上级单位ID
        depParentId: "",
        // 单位编号
        depCode: "",
        // 单位电话
        depPhone: "",
      },
      // 增加单位选中单位名称
      checkDname: "",
      // 控制修改对话框的显示和隐藏
      UpdateDepDialog: false,
      // 修改单位实体
      UpdateInfo: {
        // 单位ID
        depId: "",
        // 父级ID
        depParentId: "",
        // 单位名称
        depName: "",
        // 单位编号
        depCode: "",
        departmentParentId: "",
        // 单位电话
        depPhone: "",
        // 父单位名称
        depParentName: "",
      },
      //增加单位规则校验
      AddDepRules: {
        depName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        depCode: [
          { required: true, message: "请输入项目编号", trigger: "blur" },
        ],
        depParentId: [
          { required: true, message: "请选择所属项目", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getDepList();
    this.GetAllDepTrees();
  },
  mounted() {},
  methods: {
    // 查询单位列表信息
    async getDepList() {
      const { data: res } = await this.$axios.get(`${this.$api}/department/search`, {
        params: this.queryInfo,
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depList = res.data.rows;
      // 单位总数量
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getDepList();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getDepList();
    },

    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(`${this.$api}/department/getDepTree`);
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },
    handleNodeClick(data) {
      this.queryInfo.depId = data.depId;
      this.getDepList();
    },
    // 当选中单位时触发
    handleNodeClick2(data) {
      this.DepInfo.depParentId = data.depId;
      this.checkDname = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },
    // 增加单位
    AddDep() {
      this.$refs.addDepFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/department/add`,
          this.DepInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增项目成功");
        this.AddDepDialogVisible = false;
        this.getDepList();
        this.GetAllDepTrees();
      });
    },
    //关闭增加单位信息
    clearAddDepDialogVisible() {
      this.checkDname = "";
      this.$refs.addDepFormRef.resetFields();
    },
    //打开修改单位信息对话框
    openUpdateDep(vule) {
      this.UpdateDepDialog = true;
      // 本单位ID
      this.UpdateInfo.depId = vule.depId;
      // 本单位名称
      this.UpdateInfo.depName = vule.depName;
      // 本单位编号
      this.UpdateInfo.depCode = vule.depCode;
      // 父单位ID
      this.UpdateInfo.depParentId = vule.depParentId;
      // 本单位电话
      this.UpdateInfo.depPhone = vule.depPhone;
      // 父单位名称
      this.UpdateInfo.depParentName = vule.depParentName;
    },
    // 当选中单位时触发
    handleUpdateDepNodeClick(data) {
      // 选中后的父级ID
      this.UpdateInfo.depParentId = data.depId;
      //选中后的父单位名称
      this.UpdateInfo.depParentName = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MyUpdateSelect.handleClose();
    },

    // 修改单位信息
    async Update() {
      const { data: res } = await this.$axios.put(
        `${this.$api}/department/modfiy/${this.UpdateInfo.depId}`,
        {
          depParentId: this.UpdateInfo.depParentId,
          depName: this.UpdateInfo.depName,
          depCode: this.UpdateInfo.depCode,
          depPhone: this.UpdateInfo.depPhone,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("修改项目信息成功");
      this.getDepList();
      this.GetAllDepTrees();
      this.UpdateDepDialog = false;
    },

    //关闭修改单位信息对话框
    clearUpdateDialogVisible() {
      this.$refs.updateDepFormRef.resetFields();
    },
    // 删除单位
    async deleteDepByid(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该项目, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/department/delete/` + value.depId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("项目删除成功");
      this.getDepList();
      this.GetAllDepTrees();
    },

    
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.el-card__body {
  overflow-x: auto !important;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 40px 10px 20px 10px;
  height: calc(100vh - 220px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}



</style>


// WEBPACK FOOTER //
// src/components/Main/SystemManagement/unitsManagement.vue